/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'; // Adicionado useEffect
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box, Button, Modal, Typography, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import dayjs from 'dayjs'; // Importe dayjs para manipulação de datas
import axios from '../../services/axios';
import RelatorioPDF from './RelatorioPDF';
import { Title } from '../../styles/GlobalStyles';

dayjs.locale('pt-br');

function RelatorioModal({ open, onClose }) {
  const [ano, setAno] = useState(null); // Inicializado como null
  const [filteredAno, setFilteredAno] = useState(''); // Estado para armazenar apenas o número do ano
  const [relatorioData, setRelatorioData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showReport, setShowReport] = useState(false); // Controla exibição do relatório

  // Efeito para definir o ano atual quando o modal é aberto
  useEffect(() => {
    if (open) {
      const currentYear = dayjs().year(); // Obtém o ano atual
      setAno(dayjs().year(currentYear)); // Define o estado "ano" com o ano atual
    }
  }, [open]); // Executa sempre que o modal é aberto

  const handleGenerateReport = async () => {
    if (!ano) {
      toast.error('Por favor, insira o ano.');
      return;
    }

    const year = ano.year(); // Extrai apenas o ano como número
    setLoading(true);

    try {
      const response = await axios.get('/controledespesas/relatorioDespesas', {
        params: { ano: year },
      });
      if (response.data && response.data.length > 0) {
        setRelatorioData(response.data);
        setFilteredAno(year); // Atualiza o estado com o ano numérico
        setShowReport(true); // Exibe o relatório
        toast.success('Relatório gerado com sucesso!');
      } else {
        toast.warn('Nenhum dado encontrado para o ano informado.');
        setShowReport(false);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error || 'Erro ao gerar o relatório no servidor.'
      );
      // console.error('Erro ao gerar relatório:', error);
      setShowReport(false);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowReport(false); // Oculta o relatório
    setRelatorioData(null); // Reseta os dados do relatório
    setAno(null); // Reseta o ano selecionado
    onClose(); // Fecha o modal
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6">
          <Title>Gerar Relatório de Despesas Fixas</Title>
        </Typography>

        <Box sx={{ mb: 2 }}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="pt-br"
          >
            <Box sx={{ mb: 2 }}>
              <DatePicker
                label="Ano"
                views={['year']} // Limita a seleção ao ano
                value={ano}
                onChange={(newValue) => setAno(newValue)} // Atualiza o estado com o objeto Day.js
                // eslint-disable-next-line react/jsx-props-no-spreading
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </Box>
          </LocalizationProvider>
        </Box>

        {/* Botões */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={handleGenerateReport}
            disabled={loading}
          >
            {loading ? 'Carregando...' : 'Gerar Relatório'}
          </Button>

          <Button
            variant="contained"
            color="secondary"
            disabled={loading}
            onClick={handleClose}
          >
            Fechar
          </Button>
        </Box>

        {/* Exibição do relatório */}
        {showReport && relatorioData && (
          <Box>
            {/* Visualizador PDF */}
            <PDFViewer style={{ width: '100%', height: '500px' }}>
              <RelatorioPDF data={relatorioData} year={filteredAno} />
            </PDFViewer>

            {/* Botão para Download */}
            <PDFDownloadLink
              document={
                <RelatorioPDF data={relatorioData} year={filteredAno} />
              }
              fileName={`Relatorio_Despesas_${filteredAno}.pdf`}
              style={{ textDecoration: 'none' }}
            >
              <Button variant="contained" color="secondary" sx={{ mt: 2 }}>
                Baixar PDF
              </Button>
            </PDFDownloadLink>
          </Box>
        )}
      </Box>
    </Modal>
  );
}

export default RelatorioModal;
